export default function BorderBottom({ className, title, link, small = false }) {
  const sizing = small
    ? "min-w-[80px] py-1.5 px-3 text-xs"
    : "min-w-[120px] py-[10px] px-[25px] text-lg";

  return (
    <button
      className={`${sizing}
        bg-black text-slate-50 font-mono font-medium border-2 border-transparent
        hover:bg-white hover:text-black hover:border-emerald-500 hover:shadow-xl
        transition ease-out duration-500 ${className}`}
    >
      <a href={link} target="_blank" rel="noreferrer">
        {title}
      </a>
    </button>
  );
}
